/** ***************************************************************************
 *   This polyfill adds compatibility to all Browsers supporting ES5
 ****************************************************************************** */

// Adding forEach support for IE
if (window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = function (callback, arg) {
        const thisArg = arg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

if (!Object.fromEntries) {
    Object.fromEntries = (iterable) => {
        return [...iterable].reduce((obj, [key, val]) => {
            obj[key] = val;
            return obj;
        }, {});
    };
}
